import { render, staticRenderFns } from "./collectindividual.vue?vue&type=template&id=14dc0e20&scoped=true&"
import script from "./collectindividual.vue?vue&type=script&lang=js&"
export * from "./collectindividual.vue?vue&type=script&lang=js&"
import style0 from "./collectindividual.vue?vue&type=style&index=0&id=14dc0e20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dc0e20",
  null
  
)

component.options.__file = "collectindividual.vue"
export default component.exports